import { render } from "./CounselorCard.vue?vue&type=template&id=120cdc60"
import script from "./CounselorCard.vue?vue&type=script&lang=js"
export * from "./CounselorCard.vue?vue&type=script&lang=js"

import "./CounselorCard.vue?vue&type=style&index=0&id=120cdc60&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__